var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 39,
    viewBox: "0 0 27 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.5625C12.2568 18.5625 11.0645 18.0686 10.1854 17.1896C9.30636 16.3105 8.8125 15.1182 8.8125 13.875C8.8125 12.6318 9.30636 11.4395 10.1854 10.5604C11.0645 9.68136 12.2568 9.1875 13.5 9.1875C14.7432 9.1875 15.9355 9.68136 16.8146 10.5604C17.6936 11.4395 18.1875 12.6318 18.1875 13.875C18.1875 14.4906 18.0663 15.1001 17.8307 15.6688C17.5951 16.2375 17.2498 16.7543 16.8146 17.1896C16.3793 17.6248 15.8625 17.9701 15.2938 18.2057C14.7251 18.4413 14.1156 18.5625 13.5 18.5625ZM13.5 0.75C10.019 0.75 6.68064 2.13281 4.21922 4.59422C1.75781 7.05564 0.375 10.394 0.375 13.875C0.375 23.7188 13.5 38.25 13.5 38.25C13.5 38.25 26.625 23.7188 26.625 13.875C26.625 10.394 25.2422 7.05564 22.7808 4.59422C20.3194 2.13281 16.981 0.75 13.5 0.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1f9d41575efae58a261ebe25d0f15f68.svg";
export { ForwardRef as ReactComponent };